"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroceryItemsFromRecipesMutationOptions = exports.createGroceryItemsFromRecipesMutation = void 0;
const client_1 = require("@apollo/client");
exports.createGroceryItemsFromRecipesMutation = client_1.gql `
  mutation CreateGroceryItemsFromRecipes(
    $input: CreateGroceryItemsFromRecipesInput!
  ) {
    createGroceryItemsFromRecipes(input: $input) {
      groceryItems {
        ...GroceryListItem
      }
    }
  }
`;
exports.createGroceryItemsFromRecipesMutationOptions = (variables) => ({
    variables,
});
//# sourceMappingURL=createGroceryItemsFromRecipes.js.map